'use client';

import { FC, ReactNode } from 'react';
import { HighLightData } from '@wwe-portal/entities/dashboard.type';
import Link from 'next/link';
import { sendHighlightBannerClick } from '@wwe-portal/web/libs/analytics/global';
import { getDashboardPipStore } from '@wwe-portal/web/providers/stores/dashboard-pip-store';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';

export const HighlightLink: FC<{
  item: HighLightData['items'][number];
  index: number;
  children: ReactNode;
  className?: string;
}> = ({ item, index, className, children }) => {
  const isAuthenticated = useIsAuthenticated();
  return (
    <Link
      href={item.destination}
      className={className}
      onClick={() => {
        if (isAuthenticated) {
          getDashboardPipStore().getState().markBannerShowed(item);
        }

        sendHighlightBannerClick({
          itemName: item.title,
          destination: item.destination,
          index,
        });
      }}
    >
      {children}
    </Link>
  );
};
